import { useState } from 'react'
import { MethodTag } from '@/shared/components'
import type { ActionSummary } from '@/core/types/api.types'

export function ActionList({
  actions,
  selected,
  onSelect,
}: {
  actions: ActionSummary[]
  selected: string | null
  onSelect: (actionId: string) => void
}) {
  const [showLookups, setShowLookups] = useState(false)

  const primary = actions.filter((a) => !a.is_lookup)
  const lookups = actions.filter((a) => a.is_lookup)
  const shown = showLookups ? [...primary, ...lookups] : primary

  return (
    <div className="stack" style={{ gap: 8 }}>
      <div className="stack" style={{ gap: 4 }}>
        {shown.map((action) => (
          <button
            key={action.id}
            type="button"
            className="card"
            onClick={() => onSelect(action.id)}
            style={{
              textAlign: 'left',
              cursor: 'pointer',
              padding: '10px 12px',
              borderColor:
                selected === action.id ? 'var(--accent)' : 'var(--border)',
              background:
                selected === action.id ? 'var(--accent-soft)' : 'var(--surface)',
              font: 'inherit',
              color: 'inherit',
            }}
          >
            <div className="row-tight" style={{ marginBottom: 3 }}>
              <MethodTag method={action.method} />
              <span style={{ fontWeight: 570 }}>{action.name}</span>
              {action.is_lookup && <span className="badge badge-accent">lookup</span>}
              {action.paginated && <span className="badge badge-neutral">paged</span>}
            </div>
            <div className="small muted" style={{ lineHeight: 1.4 }}>
              {action.description}
            </div>
          </button>
        ))}
      </div>

      {lookups.length > 0 && (
        <button
          type="button"
          className="btn btn-ghost btn-sm"
          style={{ alignSelf: 'flex-start' }}
          onClick={() => setShowLookups((v) => !v)}
        >
          {showLookups ? 'Hide' : 'Show'} {lookups.length} lookup action
          {lookups.length === 1 ? '' : 's'}
        </button>
      )}

      {lookups.length > 0 && !showLookups && (
        <p className="small faint" style={{ margin: 0 }}>
          Lookup actions exist to populate dropdowns on the actions above.
        </p>
      )}
    </div>
  )
}
